import { Component, ViewChild } from '@angular/core';
import { DisplayServiceProvider } from '../../../../core/services/display-service/display-service';
import { ENVIRONMENT } from '../../../../../../environments/environment';
import { IonicPage, ModalController } from 'ionic-angular';
import { ListConfig } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { ListRendererComponent } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { StorageServiceProvider } from '../../../../core/services/storage-service/storage-service';
import { TextServiceProvider } from '../../../../core/services/text-service/text-service';
import { UserTask } from '../../../interfaces/user-task.interface';
import { UserTaskPreviewPage } from '../../user-task-preview/user-task-preview';
import { SimpleFilterSet } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/simple-filter-set.interface';

@IonicPage()
@Component({
  selector: 'page-user-task-new-list',
  templateUrl: 'user-task-new-list.html',
})
export class UserTaskNewListPage {
  @ViewChild(ListRendererComponent) list: ListRendererComponent;
  public config: ListConfig;
  public db: any;
  public engineUrl = ENVIRONMENT.engineUrl;
  public loading: boolean = true;
  public filters: SimpleFilterSet;

  constructor(
    private displayService: DisplayServiceProvider,
    private modalCtrl: ModalController,
    private storageService: StorageServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  ngOnInit() {
    this.db = this.storageService.db;
    this.config = this.displayService.getScreenComponent('user_tasks_new', 'user_tasks_new');
    const filterConfig = this.displayService.getScreenComponent('user_tasks_new_filters', 'user_tasks_new_filters');
    this.filters = filterConfig.filters;
  }

  public goTo($event: { viewId: string; element: UserTask }) {
    const modal = this.modalCtrl.create(UserTaskPreviewPage, { userTask: $event.element, disabled: true, taskType: 'new' });
    modal.onDidDismiss(() => {
      this.loading = true;
      this.list.reload();
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-new-list/user-task-new-list.ts